import React, { useEffect, useRef, useState } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography, FormControl, InputLabel, Select, Container, MenuItem, Button, TextField } from "@mui/material"
import bonnaLogo from "../../assets/img/logobonna_b.png"
import { IoMdCloseCircle } from "react-icons/io";
import { actionTypes } from '../../helper/data';
import { modalStyles } from '../../styles/globalStlye';
import useFeedbackCall from '../../hooks/useFeedbackCall';
import { normalizeEmail } from '../../helper/contactValidation';
import { toastWarnNotify } from '../../helper/ToastNotify';


const ActionType_Modal = ({ handleClose_action, open_action, info, setInfo }) => {

    const { putFireData, getFireData, sendActionMail } = useFeedbackCall()
    const initialActionResult = useRef("")
    const openedRecordId = useRef(null)
    const [isSubmitting, setIsSubmitting] = useState(false)


    useEffect(() => {
        if (!open_action) {
            openedRecordId.current = null
            return
        }

        if (openedRecordId.current === info.id) return

        openedRecordId.current = info.id
        initialActionResult.current = String(info.actionResult ?? "").trim()

        if (info.actionResult === undefined || info.actionType === undefined) {
            setInfo(prevInfo => ({
                ...prevInfo,
                actionResult: prevInfo.actionResult ?? "",
                actionType: prevInfo.actionType ?? ""
            }))
        }
    }, [open_action, info, setInfo])


    const handleChange = (e) => {

        const { name, value } = e.target

        setInfo(prevData => ({
            ...prevData,
            [name]: value
        }))

    }


    const handleSubmit = async (e) => {

        e.preventDefault()

        const addressByType = {
            sikayet: "sikayet",
            oneriTalep: "oneri-talep",
            tesekkur: "tesekkur",
            ramakkala: "ramakkala",
            etiklik: "etiklik"
        }

        const address = addressByType[info.type]
        if (!address) return

        const currentActionResult = String(info.actionResult ?? "").trim()
        // Mail yalnızca dolu ve önceki kayıttan gerçekten farklı bir açıklamada tetiklenir;
        // sadece aksiyon tipi değişiklikleri veya aynı açıklamanın tekrar kaydı mail üretmez.
        const shouldSendMail = currentActionResult !== "" && currentActionResult !== initialActionResult.current
        // Etik bildirimlerde anonimlik korunur: e-posta yoksa mail fonksiyonu hiç çağrılmaz.
        const isAnonymousEthics = info.type === "etiklik" && normalizeEmail(info.email) === ""

        setIsSubmitting(true)

        try {
            // Önce Firebase güncellemesi; başarısızsa mail kesinlikle gönderilmez.
            const updateSucceeded = await putFireData(address, info)

            if (!updateSucceeded) return

            if (shouldSendMail) {
                if (isAnonymousEthics) {
                    toastWarnNotify('Anonim kayıt: Bilgilendirme maili gönderilmedi.')
                } else {
                    await sendActionMail(info)
                }
            }

            initialActionResult.current = currentActionResult
            getFireData(address)
            handleClose_action()
        } finally {
            setIsSubmitting(false)
        }
    }


    return (
        <div>

            <Modal
                open={open_action}
                onClose={handleClose_action}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"

            >
                <Box sx={modalStyles}>

                    <IoMdCloseCircle size={30} cursor={'pointer'} color='red' onClick={handleClose_action} />

                    <img src={bonnaLogo} alt="Bonna" style={{ width: '125px', margin: 'auto' }} />

                    <Box display={'flex'} flexDirection={'column'} gap={3}>

                        <Box display={'flex'} justifyContent={'center'} gap={5} py={5}>

                            <Typography align='center' fontWeight={700}>Konu : {info?.type}</Typography>

                            <Typography align='center' fontWeight={700}>Tarih : {info?.datetime}</Typography>

                        </Box>

                        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={3} py={3}>

                            <Typography align='center' fontWeight={700}>Ad Soyad : {info?.name} {info?.surname}</Typography>
                            <Typography align='center' fontWeight={700}>Telefon : {info?.phone}</Typography>
                            <Typography align='center' fontWeight={700}>Email : {info?.email}</Typography>
                            <Typography align='center' fontWeight={700}>Lokasyon : {info?.location}</Typography>


                            {
                                info.type !== "ramakkala" && (
                                    <Box display={'flex'} flexDirection={'column'} gap={3}>
                                        <Typography align='center' fontWeight={700}>Konu : {info?.topic}</Typography>
                                        <Typography align='center' fontWeight={700}>Detay : {info?.detail}</Typography>
                                    </Box>
                                )
                            }

                        </Box>


                        {

                            info.type === "oneriTalep" && (

                                <Box display={'flex'} flexDirection={'column'} gap={3}>
                                    {/* <Typography align='center' fontWeight={700}>Konu : {info?.topic}</Typography> */}
                                    <Typography align='center' fontWeight={700}>Öneri Konusu : {info?.oneriler}</Typography>
                                    <Typography align='center' fontWeight={700}>Fayda : {info?.katkiKonusu}</Typography>
                                </Box>

                            )
                        }

                        {
                            info.type === "ramakkala" && (
                                <Box display={'flex'} flexDirection={'column'} gap={3}>
                                    <Typography align='center' fontWeight={700}>Bonna Çalışanı : {info?.bonnaUser}</Typography>
                                    <Typography align='center' fontWeight={700}>Ramak Kala Detay : {info?.ramakkaladetay}</Typography>
                                    <Typography align='center' fontWeight={700}>Öneri Açıklaması : {info?.oneri}</Typography>
                                </Box>
                            )
                        }


                        <Container sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center', mt: 10 }} component={'form'} onSubmit={handleSubmit}>

                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap',alignItems:'center' }}>

                                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:1}}>
                                <FormControl sx={{ width: '400px' }}>
                                    <InputLabel id="actionType">Aksiyon Tipi</InputLabel>
                                    <Select
                                        name='actionType'
                                        id='actionType'
                                        label='actionType'
                                        labelId='actionType'
                                        onChange={handleChange}
                                        value={info.actionType}
                                    >
                                        {
                                            actionTypes.map((item, index) => (
                                                <MenuItem key={index} value={item}>{item}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                                <Button color='error' onClick={() => setInfo({ ...info, actionType: "" })}>Reset</Button>
                                </Box>

                                <TextField
                                    multiline
                                    rows={8}
                                    sx={{ width: '400px' }}
                                    name='actionResult'
                                    id='actionResult'
                                    label='Açıklama'
                                    onChange={handleChange}
                                    value={info.actionResult}
                                >

                                </TextField>
                            </Box>

                            <Button disabled={isSubmitting} variant='contained' type='submit'>
                                {isSubmitting ? 'Kaydediliyor...' : 'Kaydet'}
                            </Button>
                        </Container>

                    </Box>




                </Box>

            </Modal>

        </div>
    )
}

export default ActionType_Modal